export enum UserKindEnum {
  Responsible = 'responsible',
  Collaborator = 'collaborator'
}
